module.exports = __webpack_public_path__ + "static/media/verset_2Tim2_old.6d0d6455.svg";